// extracted by mini-css-extract-plugin
export default {"cardBox":"PokeCard_cardBox__6QW-f","pokeName":"PokeCard_pokeName__vDDgU"};